let commonGlobalFilter: any
export function globalFilterMagic(el: Node, { Alpine }: any) {
  if (!commonGlobalFilter) {
    commonGlobalFilter = buildGlobalFilter(Alpine)
  }
  return commonGlobalFilter
}
function buildGlobalFilter(Alpine: any) {
  const rawGlobalFilter = new URLSearchParams(window.location.search).get('filter') ?? '{}'
  const globalFilter = rawGlobalFilter ? JSON.parse(rawGlobalFilter) : {}

  const filter = Alpine.reactive(globalFilter)
  return new Proxy(filter, {
    // @ts-ignore
    deleteProperty(target, prop) {
      if (prop in target) {
        delete filter[prop]
        // resetting global filter
        const urlParams = new URLSearchParams(window.location.search)
        if (Object.keys(filter).length) {
          urlParams.set('filter', JSON.stringify({ ...globalFilter }))
        } else {
          urlParams.delete('filter')
        }

        const newURL = window.location.pathname + '?' + urlParams.toString()
        window.history.pushState({}, '', newURL)
      }
    },
    set(target, name, newValue) {
      if (typeof name === 'string') {
        const globalName = name.startsWith('!') ? name.substring(1) : name
        // assigning to global filter
        const urlParams = new URLSearchParams(window.location.search)
        urlParams.set('filter', JSON.stringify({ ...globalFilter, [globalName]: newValue }))
        const newURL = window.location.pathname + '?' + urlParams.toString()
        window.history.pushState({}, '', newURL)
        filter[globalName] = newValue
      }

      return true
    }
  })
}

const stageFiltersMap = new WeakMap()

export function filterMagic(el: Node, { Alpine }: any) {
  const stageEl = (el as Element).closest('cnc-stage,cnc-block') as Element
  let filter
  if (stageEl && stageFiltersMap.has(stageEl)) {
    filter = stageFiltersMap.get(stageEl)
  } else if (stageEl) {
    filter = buildStageFilter(stageEl, Alpine)
    stageFiltersMap.set(stageEl, filter)
  } else {
    console.warn('Cannot find stage element in filterMagic')
    filter = buildStageFilter(stageEl, Alpine)
  }

  return filter
}

function buildStageFilter(stageEl: Element, Alpine: any) {
  const globalFilter = globalFilterMagic(stageEl, { Alpine })
  // TODO: Make this support nesting cnc-stages
  const localUrl = stageEl ? Alpine.evaluate(stageEl, 'href') : '/'
  const localName = stageEl ? Alpine.evaluate(stageEl, 'name') : null

  const localUrlParts = localUrl.split('?')
  const localParams = new URLSearchParams(localUrlParts[1] ?? '')
  const localFilter = JSON.parse(localParams.get('filter') ?? '{}')

  const filter = Alpine.reactive({ ...globalFilter, ...localFilter })
  return new Proxy(filter, {
    set(target, name, newValue) {
      if (typeof name === 'string') {
        if (name.startsWith('!')) {
          // assigning to global filter
          globalFilter[name.substring(1)] = newValue
          filter[name.substring(1)] = newValue
        } else {
          localParams.set('filter', JSON.stringify({ ...localFilter, [name]: newValue }))
          const urlParams = new URLSearchParams(window.location.search)
          urlParams.set('__' + localName, localUrlParts[0] + '?' + localParams.toString())
          const newURL = window.location.pathname + '?' + urlParams.toString()
          window.history.pushState({}, '', newURL)
          filter[name] = newValue
          localFilter[name] = newValue
        }
      }

      return true
    }
  })
}
